/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseShouldShowLimitAlert,
    PressReleaseShouldShowLimitAlertFromJSON,
    PressReleaseShouldShowLimitAlertFromJSONTyped,
    PressReleaseShouldShowLimitAlertToJSON,
} from './PressReleaseShouldShowLimitAlert';

/**
 * GET /press_release/should_show_limit_alert
 * @export
 * @interface GetShouldShowLimitAlertResponse
 */
export interface GetShouldShowLimitAlertResponse {
    /**
     * 
     * @type {number}
     * @memberof GetShouldShowLimitAlertResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetShouldShowLimitAlertResponse
     */
    message: string;
    /**
     * 
     * @type {PressReleaseShouldShowLimitAlert}
     * @memberof GetShouldShowLimitAlertResponse
     */
    data: PressReleaseShouldShowLimitAlert;
}

export function GetShouldShowLimitAlertResponseFromJSON(json: any): GetShouldShowLimitAlertResponse {
    return GetShouldShowLimitAlertResponseFromJSONTyped(json, false);
}

export function GetShouldShowLimitAlertResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetShouldShowLimitAlertResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressReleaseShouldShowLimitAlertFromJSON(json['data']),
    };
}

export function GetShouldShowLimitAlertResponseToJSON(value?: GetShouldShowLimitAlertResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressReleaseShouldShowLimitAlertToJSON(value.data),
    };
}

